import { useAccountCreationFlow } from "../../../application/v2";
import { UnauthenticatedLayoutV2 } from "../../../ui/layout/v2";
import { SignUpPageV2 } from "../../../ui/pages/v2/SignUpPage";

export function SignUpV2Route() {
  const accountCreation = useAccountCreationFlow();

  return (
    <UnauthenticatedLayoutV2>
      <SignUpPageV2
        accountError={accountCreation.accountError}
        activeStep={accountCreation.activeStep}
        emailVerificationError={accountCreation.emailVerificationError}
        isEmailVerificationChecking={
          accountCreation.isEmailVerificationChecking
        }
        isEmailVerificationPending={accountCreation.isEmailVerificationPending}
        isVerificationEmailResending={
          accountCreation.isVerificationEmailResending
        }
        invitation={accountCreation.invitation}
        invitationAcceptError={accountCreation.invitationAcceptError}
        invitationError={accountCreation.invitationError}
        isAcceptingInvitation={accountCreation.isAcceptingInvitation}
        isAccountSubmitting={accountCreation.isAccountSubmitting}
        isInvitation={accountCreation.isInvitation}
        isLoadingInvitation={accountCreation.isLoadingInvitation}
        onCheckEmailVerification={accountCreation.checkEmailVerification}
        onComplete={accountCreation.complete}
        onCreateAccount={accountCreation.createAccount}
        onFinishInvitation={accountCreation.finishInvitation}
        onResendVerificationEmail={accountCreation.resendVerificationEmail}
        onSkip={accountCreation.skip}
        onStepChange={accountCreation.setActiveStep}
        provisioningView={accountCreation.provisioningView}
        verificationEmail={accountCreation.verificationEmail}
      />
    </UnauthenticatedLayoutV2>
  );
}
